import { forwardRef, useState } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'
import classNames from 'classnames'
import { Eye, EyeOff } from 'lucide-react'
import styles from './style.module.css'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
  iconLeft?: ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, iconLeft, invalid = false, ...rest }, ref) => {
    if (!iconLeft) {
      return (
        <input
          ref={ref}
          className={classNames(styles.input, className, { [styles.invalid]: invalid })}
          aria-invalid={invalid}
          {...rest}
        />
      )
    }

    return (
      <div className={classNames(styles.group, { [styles.invalid]: invalid })}>
        <span className={styles.icon}>{iconLeft}</span>
        <input
          ref={ref}
          className={classNames(styles.input, styles.withIcon, className)}
          aria-invalid={invalid}
          {...rest}
        />
      </div>
    )
  },
)

Input.displayName = 'Input'

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid = false, ...rest }, ref) => {
    const [visible, setVisible] = useState(false)

    return (
      <div className={classNames(styles.group, { [styles.invalid]: invalid })}>
        <input
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={classNames(styles.input, styles.withToggle, className)}
          aria-invalid={invalid}
          {...rest}
        />
        <button
          type="button"
          className={styles.toggle}
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        >
          {visible ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    )
  },
)

PasswordInput.displayName = 'PasswordInput'
